import Icon from '@mui/icons-material/FilterFrames';
import { EditProductTypeOptionItem } from './EditProductTypeOptionItem';
import { ShowProductTypeOptionItem } from './ShowProductTypeOptionItem';

export default {
      icon: Icon,
      edit: EditProductTypeOptionItem,
      show: ShowProductTypeOptionItem,
}